/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { permissionSchemePageResource } from '@jira/router-resources__admin-pages-permissions/src/permissionSchemePageResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPermissionSchemesRoute } from '@jira/router-routes__admin-pages-permission-schemes-routes/src/globalSettingsPermissionSchemesRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PermissionSchemePage, {
	LazyPermissionSchemePage,
} from './ui/spa/admin-pages/permission-schemes/permission-scheme-page/index.tsx';

export const globalSettingsPermissionSchemesRouteEntry: Route = createEntry(
	globalSettingsPermissionSchemesRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.configure-permission-scheme',
		// eslint-disable-next-line no-restricted-syntax
		component: PermissionSchemePage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			permissionSchemePageResource,
		],

		canTransitionIn: () => true,
		forPaint: [LazyAtlassianNavigation, LazyPermissionSchemePage],

		meta: {
			reporting: {
				id: 'PermissionScheme',
				packageName: 'jiraAdminPagesPermissionScheme',
				teamName: 'gordian',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
